<!-- navbar component -->
<app-navbar></app-navbar>

<!-- router content -->
<router-outlet></router-outlet>

<!-- footer component -->
<app-footer></app-footer>